import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ResidentialStore } from '../../stores/residential.store';
import { ResidentialModel } from '../../models/residential.model';
import { GalleryPage } from '../gallery/gallery';

@Component({
  selector: 'page-residential',
  templateUrl: 'residential.html',
})
export class ResidentialPage {

    public id: string = '';
    public title: string = '';
    public segment: string = 'data';
    public model: ResidentialModel = new ResidentialModel();

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                private store: ResidentialStore) {

        this.id = navParams.data.Id_Pratica;
        this.title = navParams.data.N_Pratica + ' - Residenziali';        
    }

    ionViewDidLoad() {
        // console.log('ionViewDidLoad Residential');        

        this.store
            .load(this.id)
            .then(() => {
                this.model = new ResidentialModel(this.store.data);
            });
    }

    private isSale(): boolean {

        return (this.model && this.model.Opzione != 'A');
    }

    private isRental(): boolean {

        return (this.model && this.model.Opzione != 'V');            
    }
    
    private onHeaderClick(event) {
        // console.log('[ResidentialPage] onHeaderClick | event:');
        // console.log(event);
    }

    private onSegmentChange(event) {
        // console.log('[ResidentialPage] onSegmentChange | event:');
        // console.log(event);

        // console.log('[ResidentialPage] onSegmentChange | segment:' + this.segment);

        if ('images' == this.segment)
        {
            if (!this.store.images)
                this.store.loadImages();
        }
    }

    private openGallery(index: number) {

        // console.log('[ResidentialPage] openGallery | index: ' + index);

        let params = {
            title: this.title,
            images: this.store.images,
            index: index - 1
        };

        this.navCtrl.push(GalleryPage, params);
    }
}



// WEBPACK FOOTER //
// ./src/pages/residential/residential.ts